// src/pages/Contacts/Contacts.jsx
import React from 'react';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs';
import { REQUISITES, REQUISITES_ADDRESS } from '../../utils/requisites.js';

export const Contacts = () => {
  const breadcrumbs = [{ label: 'Контакты', path: '/contacts' }];

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />
        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '16px',
        }}>
          Контакты
        </h1>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px' }}>
          <div>
            <h3 style={{ fontWeight: 600, marginBottom: '8px' }}>Телефон</h3>
            <p style={{ fontSize: '18px', color: 'rgb(var(--c-accent))' }}>
              <a href={REQUISITES.phoneHref} style={{ color: 'rgb(var(--c-accent))' }}>
                {REQUISITES.phone}
              </a>
            </p>
            <h3 style={{ fontWeight: 600, marginTop: '16px', marginBottom: '8px' }}>Email</h3>
            {/* ⚠️ Домен исправлен 2026-10-07: было `info@studio-reklama.ru`.
                Проверено замером: у `studio-reklama.ru` НЕТ A-записи — домен
                не существует. Наш домен — `reklama-oskol.ru`.
                ⚠️ Почта на нём ещё не настроена (MX нет) — см. техдолг. */}
            <p style={{ fontSize: '16px' }}>
              <a href={`mailto:${REQUISITES.email}`} style={{ color: 'rgb(var(--c-accent))' }}>
                {REQUISITES.email}
              </a>
            </p>
            <h3 style={{ fontWeight: 600, marginTop: '16px', marginBottom: '8px' }}>Адрес</h3>
            {/* Данные из ЕГРИП: точный адрес (улица, дом) в регистре не
                публикуется, поэтому указываем город и область. */}
            <p style={{ fontSize: '16px', color: 'rgb(var(--c-text-secondary))' }}>{REQUISITES_ADDRESS}</p>

            <h3 style={{ fontWeight: 600, marginTop: '24px', marginBottom: '8px' }}>Реквизиты</h3>
            <p style={{ fontSize: '14px', color: 'rgb(var(--c-text-secondary))', lineHeight: 1.7 }}>
              {REQUISITES.legalName}
              <br />
              ИНН {REQUISITES.inn}
              <br />
              ОГРНИП {REQUISITES.ogrnip}
            </p>
          </div>
          <div style={{
            backgroundColor: 'rgb(var(--c-border))',
            borderRadius: '16px',
            minHeight: '300px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'rgb(var(--c-text-secondary))',
          }}>
            Карта
          </div>
        </div>
      </div>
    </div>
  );
};